import { queryOptions } from '@tanstack/react-query';
import HttpClient from '../../Api/HttpClient';

export function transformCardToUi(card) {
  return {
    id: card.id,
    name: card.title,
    startDate: card.start_date,
    endDate: card.end_date,
    taskType: card.task_type_details?.id,
    duration: card.duration,
    offset: card.offset,
    documentsCount: card.document_count,
    description: card.description,
    internalNote: card.internal_note,
    weightPercentage: card.weight_percentage,
    weight: card.weight,
    stepsCount: card.steps_count,
    playbookOwnerAssigned: card.template_owner_assigned,
    timing: card.task_timing,
    referencedFlowId: card.timing_ref_task,
    clientVisible: card.client_visible,
    side: card.side,
    defaultAssignee: card.template_owner_assigned
      ? 'project_owner'
      : card.internal_assignee_details
        ? card.internal_assignee_details.id
        : 'unassigned',
    owner: card.owner_details,
    internalAssignee: card.internal_assignee_details,
    externalAssignee: card.external_assignee_details,
    isCompleted: card.is_completed,
    buyerCompany: card.buyer_company_details,
    projectId: card.board,
  };
}

export function getCard({ cardId }) {
  return queryOptions({
    queryKey: ['card', cardId],
    queryFn: async () => {
      const { data } = await HttpClient.getCard({ cardId });

      const card = data[0];

      return transformCardToUi(card);
    },
  });
}

export function getMaapLink({ taskId, userId }) {
  return queryOptions({
    queryKey: ['maapLink', taskId, userId],
    queryFn: async () => {
      const { data } = await HttpClient.getMaapLink({ card: taskId, user: userId });

      return data.url;
    },
  });
}

export function getTaskCommentsEvents({ taskId }) {
  return queryOptions({
    queryKey: ['taskCommentsEvents', taskId],
    queryFn: async () => {
      const { data } = await HttpClient.loadComments({ id: taskId });

      const internalComments = [];
      const externalComments = [];
      const events = [];

      for (const item of data.events_and_comments) {
        if (item.object_type === 'event') {
          events.push(item);
        } else if (item.object_type === 'comment') {
          if (item.client_facing) {
            externalComments.push(item);
          } else {
            internalComments.push(item);
          }
        }
      }

      return { internalComments, externalComments, events };
    },
  });
}

export function getTaskDocuments({ taskId }) {
  return queryOptions({
    queryKey: ['cardDocuments', taskId],
    queryFn: async () => {
      const { data } = await HttpClient.getTaskDocuments({ taskId });

      return Array.isArray(data) ? data : [];
    },
  });
}

export function getTaskSteps({ taskId }) {
  return queryOptions({
    queryKey: ['cardSteps', taskId],
    queryFn: async () => {
      const { data } = await HttpClient.getTaskSteps({ taskId });

      return data;
    },
  });
}
